<template>
  <div v-if="promoCodesActive">
    <!--applied: code + what it saves-->
    <div v-if="appliedPromotion" class="promo-applied d-flex align-center px-2 py-1">
      <v-icon color="success" small class="mr-2">mdi-ticket-percent</v-icon>
      <div class="flex-grow-1">
        <div class="caption font-weight-bold success--text">
          {{ appliedPromotion.code }}
        </div>
        <div v-if="appliedPromotion.description" class="caption grey--text">
          {{ appliedPromotion.description }}
        </div>
      </div>
      <strong v-if="promoDiscountAmount > 0" class="caption success--text mr-1">
        -{{ promoDiscountAmount | currency }}
      </strong>
      <v-btn icon x-small color="error" @click="confirmRemove">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>

    <!--collapsed trigger-->
    <v-btn
      v-else-if="!expanded"
      block
      text
      small
      color="accent"
      class="text-capitalize justify-start px-1"
      @click="expanded = true"
    >
      <v-icon small class="mr-2">mdi-ticket-percent-outline</v-icon>
      {{ $t("delivery.lang_havePromoCode") }}
      <v-spacer />
      <v-icon x-small>mdi-chevron-right</v-icon>
    </v-btn>

    <!--input-->
    <v-text-field
      v-else
      v-model="code"
      :placeholder="$t('delivery.lang_promoCode')"
      :disabled="promoChecking"
      class="rounded-lg promo-input"
      outlined
      rounded
      dense
      hide-details
      autofocus
      @keyup.enter="apply"
      @input.native="onInputText"
      @paste.native="onPasteText"
    >
      <template v-slot:append>
        <v-btn
          depressed
          x-small
          color="accent"
          class="rounded-lg promo-apply"
          :disabled="!code || promoChecking"
          :loading="promoChecking"
          @click="apply"
        >
          {{ $t("delivery.lang_apply") }}
        </v-btn>
      </template>
    </v-text-field>

    <promo-target-dialog v-model="targetFlow" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import promoCode from "@/mixins/promoCode";
import inputSanitizer from "@/mixins/inputSanitizer";
import PromoTargetDialog from "./PromoTargetDialog";

export default {
  name: "PromoCodeRow",

  components: { PromoTargetDialog },

  mixins: [promoCode, inputSanitizer],

  data() {
    return {
      code: null,
      expanded: false,
      targetFlow: null
    };
  },

  computed: {
    ...createNamespacedHelpers("Order").mapGetters([
      "appliedPromotion",
      "promoDiscountAmount",
      "promoNotice"
    ])
  },

  watch: {
    // reconcile dropped the promo, tell the customer which condition broke
    promoNotice(notice) {
      if (!notice || !notice.rules) return;

      this.promoInfo(this.promoConditionMessage(notice, notice.rules));
      this.$store.commit("Order/clearPromoNotice");
    }
  },

  methods: {
    async apply() {
      if (!this.code || this.promoChecking) return;

      const { applied, targetFlow } = await this.redeemPromoCode(this.code);

      if (targetFlow) {
        this.reset();
        this.targetFlow = targetFlow;
        return;
      }
      if (applied) this.reset();
    },

    confirmRemove() {
      this.$swal({
        text: this.$t("delivery.lang_promoRemoveConfirm"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("delivery.lang_yes"),
        cancelButtonText: this.$t("delivery.lang_cancel"),
        showCloseButton: true,
        dangerMode: true
      }).then(({ isConfirmed }) => {
        if (isConfirmed) this.removePromoCode();
      });
    },

    reset() {
      this.code = null;
      this.expanded = false;
    }
  }
};
</script>

<style scoped>
.promo-applied {
  border: 1px solid var(--v-success-base);
  border-radius: 8px;
}

.promo-input ::v-deep input {
  text-transform: uppercase;
}

.promo-apply {
  min-height: 24px;
}
</style>
